import { FC } from 'react';

import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { recordingsModel } from '../../model';

import { SelectSort, SwitchGridList } from '../../../../shared/ui';
import { SelectMember } from '../../../team-members';
import { useRecordsView } from '../../hooks';
import { RecordCategory } from '../../../../entities/recordings';

export type Props = {
  value: number;
};

export const RecordsCount: FC<Props> = ({ value }) => (
  <p
    className={cn(
      'text-gray-700 text-sm font-normal whitespace-nowrap sm:hidden'
    )}
  >{`${value} ${value === 1 ? 'video' : 'videos'} `}</p>
);

export const RecordsSort = () => {
  const dispatch = useDispatch();
  const sort = useSelector(recordingsModel.selectors.selectSort);

  return (
    <SelectSort
      value={sort}
      onChange={(value) => dispatch(recordingsModel.actions.setSort(value))}
      className="md:w-full"
    />
  );
};

export const RecordsOwnerFilter = () => {
  const dispatch = useDispatch();

  const filterOwner = useSelector(recordingsModel.selectors.selectFilterOwner);

  return (
    <SelectMember
      value={filterOwner}
      onChange={(value) => {
        dispatch(recordingsModel.actions.setFilterOwner(value));
      }}
      className="md:hidden"
    />
  );
};

type RecordsFiltersProps = {
  type: RecordCategory;
};

export const RecordsFilters: FC<RecordsFiltersProps> = ({ type }) => {
  const { view, setView } = useRecordsView();

  return (
    <div className="md:w-full md:ml-0 ml-auto flex-nowrap gap-x-3 items-center flex">
      {type === RecordCategory.SHARED && <RecordsOwnerFilter />}
      <RecordsSort />
      <SwitchGridList
        value={view}
        onChange={(value) => setView(value)}
        className="xl:hidden"
      />
    </div>
  );
};
